import { Box, Group, Paper, Text } from '@mantine/core';
import moment from 'moment';

import {
  EORIGIN_DATE_FORMAT,
  UTBReportDataDeclarant,
  UTBReportDataGroup,
  UTBReportDataImporter,
  UTBReportDataRepresentative,
  XML_DATE_FORMAT,
} from '@e-origin/shared';

interface UTBSubHeaderProps {
  representative: UTBReportDataRepresentative;
  declarant: UTBReportDataDeclarant;
  importer: UTBReportDataImporter;
  group: UTBReportDataGroup;
  t: (path: string, variables?: Record<string, any>) => string;
}

export const UTBSubHeader = ({ representative, declarant, importer, group, t }: UTBSubHeaderProps) => {
  const EORI_NUMBER_LABEL = t('SUB_HEADER.EORI_NUMBER');
  const NAME_LABEL = t('SUB_HEADER.NAME');
  const ADDRESS_LABEL = t('SUB_HEADER.ADDRESS');

  return (
    <Paper mb="xs" p="xs">
      <Box mb="md">
        <Text fw={700}>{t('SUB_HEADER.DECLARANT')}</Text>
        <Box>
          <Text>
            {EORI_NUMBER_LABEL}: {declarant.eori}
          </Text>
          <Text>
            {NAME_LABEL}: {declarant.name}
          </Text>
          <Text>
            {ADDRESS_LABEL}: {declarant.address}
          </Text>
        </Box>
      </Box>

      <Box mb="md">
        <Group justify="space-between">
          <Text>{t('SUB_HEADER.DECLARATION_NUMBER', { movementReference: group.movementReference || '' })}</Text>
          <Text>{t('SUB_HEADER.NUMBER_ARTICLES', { value: group.numberOfArticles || 0 })}</Text>
        </Group>
        <Text>
          {t('SUB_HEADER.ACCEPTANCE_DATE', { date: group.dateOfAcceptance ? moment(group.dateOfAcceptance, XML_DATE_FORMAT).format(EORIGIN_DATE_FORMAT) : '' })}
        </Text>
        <Text>{t('SUB_HEADER.COMMERCIAL_REF', { commercialReference: group.commercialReference || '' })}</Text>
      </Box>

      <Group justify="space-between">
        <Box mb="md">
          <Text fw={700}>{t('SUB_HEADER.REPRESENTATIVE')}</Text>
          <Box>
            <Text>
              {EORI_NUMBER_LABEL}: {representative.eori}
            </Text>
            <Text>
              {NAME_LABEL}: {representative.name}
            </Text>
            <Text>
              {ADDRESS_LABEL}: {representative.address}
            </Text>
            {representative.vatLiablePerson && (
              <Text>
                {t('SUB_HEADER.VAT_LIABLE_PERSON')}: {representative.vatLiablePerson}
              </Text>
            )}
          </Box>
        </Box>

        <Box mb="md">
          <Text fw={700}>{t('SUB_HEADER.IMPORTER')}</Text>
          <Box>
            <Text>
              {EORI_NUMBER_LABEL}: {importer.eori}
            </Text>
            <Text>
              {NAME_LABEL}: {importer.name}
            </Text>
            <Text>
              {ADDRESS_LABEL}: {importer.address}
            </Text>
            <Text>
              {t('SUB_HEADER.VAT_LIABLE_PERSON')}: {importer.vatLiablePerson}
            </Text>
          </Box>
        </Box>
      </Group>
    </Paper>
  );
};
